import { combineReducers } from 'redux'
import { authReducer } from './auth'
import { userReducer } from './user'
import { inviteReducer } from './invite'
import { marketReducer } from './market'
import { tagReducer } from './tag'
import { onboardingReducer } from './onboarding'
import { contractorReducer } from './contractor'
import { activitiesReducer } from './activities'
import { teamReducer } from './team'
import { notesReducer } from './note'
import { customerReducer } from './customer'
import { mcReducer } from './mc'
import { mcOnboardingReducer } from './mc-onboarding'
import { rejectionReasonReducer } from './rejection-reason'
import { paymentReducer } from './payment'

export const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  invite: inviteReducer,
  tag: tagReducer,
  market: marketReducer,
  contractor: contractorReducer,
  onboarding: onboardingReducer,
  activities: activitiesReducer,
  team: teamReducer,
  note: notesReducer,
  mc: mcReducer,
  mcOnboarding: mcOnboardingReducer,
  customer: customerReducer,
  rejectionReason: rejectionReasonReducer,
  payment: paymentReducer,
})
